import React from "react";

export const rounds = [
  {
    name: "Articulate",
    rules: (
      <>
        <h3>ONLY WORDS.</h3> you can't say any words you're given. no actions,
        sounds or gestures
      </>
    ),
  },
  {
    name: "Charades",
    rules: (
      <>
        <h3>ONLY ACTIONS.</h3> no words or sounds. Charades rules.
      </>
    ),
  },
  {
    name: "One word",
    rules: (
      <>
        <h3>ONLY ONE WORD</h3> no words from given phrase. no actions, sounds or
        gestures
      </>
    ),
  },
  {
    name: "One pose",
    rules: (
      <>
        <h3>ONLY ONE POSE</h3> no actions, words, sounds or gestures
      </>
    ),
  },
  {
    name: "One sound",
    rules: (
      <>
        <h3>ONLY ONE SOUND</h3>no words, poses, actions or gestures
      </>
    ),
  },
];
